module.exports = __webpack_public_path__ + "images/f6555b294ee1a17b6e95192fa829cd4ac617ceb069ce8667e53bd5dfc3f8a7dc.svg";